import axios from "axios";
import {message, Modal} from "antd";

// const
const MENU_MANAGEMENT_UPDATE_DATA = "menuManagement/MENU_MANAGEMENT_UPDATE_DATA";
const MENU_MANAGEMENT_STORE_DEPLOYMENTS = "menuManagement/MENU_MANAGEMENT_STORE_DEPLOYMENTS";
const MENU_MANAGEMENT_STORE_MENUS = "menuManagement/MENU_MANAGEMENT_STORE_MENUS";
const MENU_MANAGEMENT_EDIT_MENU = "menuManagement/MENU_MANAGEMENT_EDIT_MENU";
const MENU_MANAGEMENT_ADD_MENU = "menuManagement/MENU_MANAGEMENT_ADD_MENU";
const MENU_MANAGEMENT_SET_PRIVILEGE = "menuManagement/MENU_MANAGEMENT_SET_PRIVILEGE";
// const MENU_MANAGEMENT_TOGGLE_MODAL = "menuManagement/MENU_MANAGEMENT_TOGGLE_MODAL";
const MENU_MANAGEMENT_TOGGLE_LOADING = "menuManagement/MENU_MANAGEMENT_TOGGLE_LOADING";

// reducer
export const menuManagement = (state = {

  loading: false,

  createVisible: false,
  editVisible: false,
  addVisible: false,
  setVisible: false,
  menu: {},

  name: "",
  expandedRowKeys: [],
  allExpandedKeys: [],

  deployments: [],
  menus: [],
  showMenus: [],
}, action) => {
  switch (action.type) {
    case MENU_MANAGEMENT_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    case MENU_MANAGEMENT_STORE_DEPLOYMENTS:
      return {
        ...state,
        deployments: action.data
      };
    case MENU_MANAGEMENT_STORE_MENUS:
      const allExpandedKeys = [];
      const loop = (data) => {
        data.map(item => {
          if (item.hasOwnProperty("children")) {
            if (item.children && item.children.length) {
              allExpandedKeys.push(item.id);
              loop(item.children);
            } else {
              delete item.children;
            }
          }
        });
      };
      loop(action.data);
      return {
        ...state,
        createVisible: false,
        editVisible: false,
        addVisible: false,
        setVisible: false,
        menus: action.data,
        showMenus: action.data,
        allExpandedKeys: allExpandedKeys,
        expandedRowKeys: [],
      };
    case MENU_MANAGEMENT_EDIT_MENU:
      return {
        ...state,
        menu: action.data,
        editVisible: true
      };
    case MENU_MANAGEMENT_ADD_MENU:
      return {
        ...state,
        menu: action.data,
        addVisible: true
      };
    case MENU_MANAGEMENT_SET_PRIVILEGE:
      return {
        ...state,
        menu: action.data,
        setVisible: true
      };
    // case MENU_MANAGEMENT_TOGGLE_MODAL:
    //   return {
    //     ...state,
    //     modalVisible: action.data.modalVisible,
    //     modalTitle: action.data.modalTitle,
    //     modalContent: action.data.modalContent,
    //     modalOk: action.data.modalOk,
    //     modalCancel: action.data.modalCancel,
    //     onOk: action.data.onOk,
    //     onCancel: action.data.onCancel
    //   };
    case MENU_MANAGEMENT_TOGGLE_LOADING:
      return {
        ...state,
        loading: action.data
      };
    default:
      return state
  }
};

/**
 * update data based
 */
export const updateMenuManagementData = (data) => {
  return {
    type: MENU_MANAGEMENT_UPDATE_DATA,
    data: data
  }
};

/**
 * get all deployments by enterprise id
 */
export const getDeployments = (enterpriseId) => (dispatch) => {
  dispatch(toggleLoading(true));
  axios.get(`/api-backend/deployments/web${!!enterpriseId ? `/${enterpriseId}` : ``}`, {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeDeployments(response.data));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store all deployments
 */
export const storeDeployments = (deployments) => {
  return {
    type: MENU_MANAGEMENT_STORE_DEPLOYMENTS,
    data: deployments
  }
};

/**
 * get all menu by enterprise id
 */
export const getMenus = (enterpriseId) => (dispatch) => {
  dispatch(toggleLoading(true));
  axios.get(`/api-menu/getMenus${!!enterpriseId ? `?enterpriseId=${enterpriseId}` : ``}`, {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeMenus(response.data));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store all menus
 */
export const storeMenus = (menus) => {
  return {
    type: MENU_MANAGEMENT_STORE_MENUS,
    data: menus
  }
};

/**
 * edit menu
 */
export const editMenu = (data) => {
  return {
    type: MENU_MANAGEMENT_EDIT_MENU,
    data: data
  }
};

/**
 * add menu
 */
export const addMenu = (data) => {
  return {
    type: MENU_MANAGEMENT_ADD_MENU,
    data: data
  }
};

/**
 * add menu
 */
export const setPrivilege = (data) => {
  return {
    type: MENU_MANAGEMENT_SET_PRIVILEGE,
    data: data
  }
};

/**
 * submit menus
 */
export const submitMenu = (data) => (dispatch) => {
  dispatch(toggleLoading(true));
  axios({
    method: "post",
    url: "/api-menu/submitMenu",
    contentType: "application/json",
    withCredentials: true,
    data: {
      "id": data.id,
      "parentId": data.parentId,
      "name": data.name,
      "icon": data.icon || null,
      "type": data.type,
      "url": data.url || null,
      "sort": data.sort,
      "enterpriseId": data.enterpriseId,
      "deploymentId": data.deploymentId,
      "helpPageId": data.helpPageId || null,
      "privileges": data.privileges || [],
      "isPublic": data.isPublic,
      "byProxy": data.byProxy
    },
  }).then(
    response => {
      if (response.status === 200) {
        console.log("success submit menus");
        dispatch(updateMenuManagementData({
          name: data.visible,
          value: false
        }));
        message.success("菜单提交成功！");
        dispatch(getMenus(data.enterpriseId));
      } else {
        console.error("fail to submit menus");
        message.error("菜单提交失败！");
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * delete menus
 */
export const deleteMenu = (data) => (dispatch) => {
  if (data.hasOwnProperty("children") && data.children.length > 0) {
    Modal.warning({
      title: "无法删除！",
      content: "请先删除页面节点...",
    });
  } else {
    dispatch(toggleLoading(true));
    axios({
      method: "delete",
      url: `/api-menu/deleteMenu/${data.id}`,
      contentType: "application/json",
      withCredentials: true,
    }).then(
      response => {
        if (response.status === 200) {
          console.log("success delete menu");
          message.success("菜单删除成功！");
          dispatch(toggleLoading(false));
          dispatch(getMenus(data.enterpriseId));
        } else {
          console.error("fail to delete menu");
          message.error("菜单删除失败！");
          dispatch(toggleLoading(false));
        }
      }
    );
  }
};

/**
 * filter menus
 */
export const filterMenu = (data) => (dispatch) => {
  //做一次深拷贝，保留原始数据
  let allMenus = JSON.parse(JSON.stringify(data.menus));
  //对菜单数据进行处理
  let showMenus = dealTree(allMenus, data.name);
  dispatch(updateMenuManagementData({
    name: "showMenus",
    value: showMenus
  }));
  dispatch(updateMenuManagementData({
    name: "selectedKey",
    value: ""
  }));
};
/*menu.children = menu.children.filter(item => {return item.name.indexOf(data.name) > -1})
      if(menu.children.length !== 0){
        return true;
      }else{
        return menu.name.indexOf(data.name) > -1
      }*/
export const dealTree = (itemList, searchContent) => {
    return itemList.filter(item => {
      //遍历所有结点做递归判断menu目录是否存在叶子结点，有则处理，没有判断menu目录是否包含关键字
      if(!!item.children){
        item.children = dealTree(item.children, searchContent);
        if(item.children.length !== 0){
          return true;
        }else{
          return item.name.indexOf(searchContent) > -1
        }
      }else{
        return item.name.indexOf(searchContent) > -1
      }
    })
};

// /**
//  * toggle modal
//  */
// export const toggleModal = (show) => {
//   return {
//     type: MENU_MANAGEMENT_TOGGLE_MODAL,
//     data: show
//   }
// };

/**
 * toggle loading
 */
export const toggleLoading = (show) => {
  return {
    type: MENU_MANAGEMENT_TOGGLE_LOADING,
    data: show
  }
};
